import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

interface EventEndWithoutDefectsModalProps {
  show: boolean;
  onHide: () => void;
  eventName: string;
  onConfirm: (completionNotes: string) => void;
}

const EventEndWithoutDefectsModal: React.FC<EventEndWithoutDefectsModalProps> = ({
  show,
  onHide,
  eventName,
  onConfirm
}) => {
  const [completionNotes, setCompletionNotes] = useState('');

  const handleSubmit = () => {
    onConfirm(completionNotes);
    setCompletionNotes('');
  };

  const handleClose = () => {
    setCompletionNotes('');
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>סיום אירוע - {eventName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label className="fw-bold">הערות אחרונות (אופציונלי)</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            value={completionNotes}
            onChange={(e) => setCompletionNotes(e.target.value)}
            placeholder="הוסף הערות כלליות על האירוע לאחר סיומו..."
          />
          <Form.Text className="text-muted">
            הערות אלו יוצגו בחלק "הערות לאחר סיום" בפרטי האירוע
          </Form.Text>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          ביטול
        </Button>
        <Button variant="success" onClick={handleSubmit}>
          ✅ סיים אירוע
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EventEndWithoutDefectsModal;

